import axios from 'axios';

const api = axios.create({
    baseURL: 'https://billtronapi.patronservices.in/',
    //baseURL: 'http://192.168.29.214:8080/',
    timeout: 80000,
    headers: {
        'Content-Type': 'application/json',
    }
});

// Request interceptor to add auth token
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('userToken');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// 401 on these routes means invalid credentials or OTP — let the caller show a message.
// Do not redirect (full page reload) or clear session; that blocked login error UI.
const TOKEN_AUTH_FLOW_PATHS =
    /get-client-token|generate-otp-client-token|forget-password-client-otp|verify-client-otp|reset-password-client/;

// Response interceptor for handling errors
api.interceptors.response.use(
    (response) => response,
    async (error) => {
        if (error.response?.status === 429) {
            const retryAfter = error.response.headers?.['retry-after'];
            const retryMs = retryAfter ? parseInt(retryAfter, 10) * 1000 : 30000;
            await new Promise((resolve) => setTimeout(resolve, Math.min(retryMs, 300000)));
            return api.request(error.config);
        }

        if (error.response?.status === 401) {
            const url = error.config?.url || '';
            if (!TOKEN_AUTH_FLOW_PATHS.test(url)) {
                localStorage.removeItem('userToken');
                localStorage.removeItem('userData');
                window.location.href = '/login';
            }
        }
        return Promise.reject(error);
    }
);

export const handleCatch = (error) => {
    if (error.response) {
        // Request made and server responded
        const data = error.response.data;
        let message = 'An error occurred';

        if (typeof data === 'string') {
            message = data;
        } else if (data?.title || data?.message) {
            message = data.title || data.message;
        } else if (data?.errors) {
            message = Object.values(data.errors).flat().join('\n') || message;
        }

        console.error('API Error:', message);
        return message;
    } else if (error.request) {
        console.error('Network Error');
        return 'Network Error';
    } else {
        console.error('Error:', error.message);
        return error.message;
    }
};

export default api;
